"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    IdPrefixProvider: function() {
        return _index1.IdPrefixProvider;
    },
    SLOT_CLASS_NAME_PROP_SYMBOL: function() {
        return _index.SLOT_CLASS_NAME_PROP_SYMBOL;
    },
    SLOT_ELEMENT_TYPE_SYMBOL: function() {
        return _index.SLOT_ELEMENT_TYPE_SYMBOL;
    },
    SLOT_RENDER_FUNCTION_SYMBOL: function() {
        return _index.SLOT_RENDER_FUNCTION_SYMBOL;
    },
    SSRProvider: function() {
        return _index2.SSRProvider;
    },
    applyTriggerPropsToChildren: function() {
        return _index4.applyTriggerPropsToChildren;
    },
    assertSlots: function() {
        return _index.assertSlots;
    },
    canUseDOM: function() {
        return _index2.canUseDOM;
    },
    clamp: function() {
        return _index3.clamp;
    },
    createPriorityQueue: function() {
        return _index3.createPriorityQueue;
    },
    elementContains: function() {
        return _index7.elementContains;
    },
    getEventClientCoords: function() {
        return _index5.getEventClientCoords;
    },
    getIntrinsicElementProps: function() {
        return _index.getIntrinsicElementProps;
    },
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    getNativeElementProps: function() {
        return _index3.getNativeElementProps;
    },
    getParent: function() {
        return _index7.getParent;
    },
    getPartitionedNativeProps: function() {
        return _index3.getPartitionedNativeProps;
    },
    getRTLSafeKey: function() {
        return _index3.getRTLSafeKey;
    },
    getReactElementRef: function() {
        return _index3.getReactElementRef;
    },
    getSlotClassNameProp_unstable: function() {
        return _index.getSlotClassNameProp_unstable;
    },
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    getSlots: function() {
        return _index.getSlots;
    },
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    getSlotsNext: function() {
        return _index.getSlotsNext;
    },
    getTriggerChild: function() {
        return _index4.getTriggerChild;
    },
    isFluentTrigger: function() {
        return _index4.isFluentTrigger;
    },
    isHTMLElement: function() {
        return _index3.isHTMLElement;
    },
    isInteractiveHTMLElement: function() {
        return _index3.isInteractiveHTMLElement;
    },
    isMouseEvent: function() {
        return _index5.isMouseEvent;
    },
    isResolvedShorthand: function() {
        return _index.isResolvedShorthand;
    },
    isSlot: function() {
        return _index.isSlot;
    },
    isTouchEvent: function() {
        return _index5.isTouchEvent;
    },
    mergeCallbacks: function() {
        return _index3.mergeCallbacks;
    },
    omit: function() {
        return _index3.omit;
    },
    resetIdsForTests: function() {
        return _index1.resetIdsForTests;
    },
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    resolveShorthand: function() {
        return _index.resolveShorthand;
    },
    setVirtualParent: function() {
        return _index7.setVirtualParent;
    },
    slot: function() {
        return _index.slot;
    },
    useAnimationFrame: function() {
        return _index1.useAnimationFrame;
    },
    useApplyScrollbarWidth: function() {
        return _index1.useApplyScrollbarWidth;
    },
    useControllableState: function() {
        return _index1.useControllableState;
    },
    useEventCallback: function() {
        return _index1.useEventCallback;
    },
    useFirstMount: function() {
        return _index1.useFirstMount;
    },
    useForceUpdate: function() {
        return _index1.useForceUpdate;
    },
    useId: function() {
        return _index1.useId;
    },
    useIsSSR: function() {
        return _index2.useIsSSR;
    },
    useIsomorphicLayoutEffect: function() {
        return _index1.useIsomorphicLayoutEffect;
    },
    useMergedRefs: function() {
        return _index1.useMergedRefs;
    },
    useOnClickOutside: function() {
        return _index1.useOnClickOutside;
    },
    useOnScrollOutside: function() {
        return _index1.useOnScrollOutside;
    },
    usePrevious: function() {
        return _index1.usePrevious;
    },
    useScrollbarWidth: function() {
        return _index1.useScrollbarWidth;
    },
    useSelection: function() {
        return _index6.useSelection;
    },
    useTimeout: function() {
        return _index1.useTimeout;
    }
});
const _index = require("./compose/index");
const _index1 = require("./hooks/index");
const _index2 = require("./ssr/index");
const _index3 = require("./utils/index");
const _index4 = require("./trigger/index");
const _index5 = require("./events/index");
const _index6 = require("./selection/index");
const _index7 = require("./virtualParent/index");
